export const SET_APPLICATION_SETTINGS = "SET_APPLICATION_SETTINGS";